if ($('.accordion-toggle').length) {
  $('.accordion-toggle').on('click', function() {
    // Expand / collapse
    $(this).parent().find('.accordion-content').slideToggle('fast')
    // Show active state
    if ($(this).find('.toggle-icon').hasClass('active')) {
      $(this).find('.toggle-icon').removeClass('active')
    } else {
      $(this).find('.toggle-icon').addClass('active')
    }
    // Collapse all siblings
    $('.accordion-content').not($(this).parent().find('.accordion-content')).slideUp('fast')
    $('.toggle-icon').not($(this).find('.toggle-icon')).removeClass('active')
  })

  // Default Expand Description
  if ($(window).width() >= 1100) {
    $('.product__accordion .accordion-toggle.desc').trigger('click');
  }
}
